import devices from 'devextreme/core/devices';
import React, { Fragment, useEffect, useState } from 'react';
import Badge from "react-bootstrap/Badge";
import { useIntl } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import logo from '../../../assets/images/custom/uklogo.jpg';
import { MENUITEMS } from '../../../constant/menu';
import configDB from '../../../data/customizer/config';
import { sidebarRoleManagement } from '../../../utils/UserManagement';

const Sidebar = (props) => {
    const [margin, setMargin] = useState(0);
    const [width, setWidth] = useState(0);
    const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
    const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
    const [hideRightArrow, setHideRightArrow] = useState(true);
    const [hideLeftArrow, setHideLeftArrow] = useState(true);
    const [mainmenu, setMainMenu] = useState(MENUITEMS);
    const wrapper = configDB.data.settings.sidebar.wrapper;
    const layout = "ltr";
    const location = useLocation();

    const intl = useIntl();
    const getFormatMessage = (messageKey) => {
        return intl.formatMessage({ id: messageKey, defaultMessage: messageKey });
    }
    var isMobile = devices.current().deviceType === 'phone';

    // Function to check if a menu item or its children match the current path
    const isPathMatch = (item) => {
        if (location.pathname === "/" || location.pathname === "/index") return

        if (item.path === location.pathname) {
            return true;
        }
        if (item.children) {
            return item.children.some(child =>
                child.path === location.pathname ||
                (child.children && child.children.some(subChild =>
                    subChild.path === location.pathname
                ))
            );
        }
        return false;
    };

    // Function to update active states based on current path
    const updateActiveStates = (items) => {
        return items.map(item => {
            const isActive = isPathMatch(item);
            if (isActive === undefined && item.active === true) {
                return { ...item, active: true };
            }
            const updatedItem = {
                ...item,
                active: isActive
            };

            if (item.children) {
                updatedItem.children = updateActiveStates(item.children);
                // If any child is active, parent should be active too
                updatedItem.active = updatedItem.active || updatedItem.children.some(child => child.active);
            }

            return updatedItem;
        });
    };

    useEffect(() => {
        const updatedMenu = updateActiveStates([...MENUITEMS]);
        setMainMenu(updatedMenu);
        // eslint-disable-next-line
    }, [location.pathname]);

    useEffect(() => {
        document.querySelector(".page-main-header").classList.remove('open');
        document.querySelector(".page-sidebar").classList.remove('open');

        window.addEventListener('resize', handleResize);
        handleResize();

        setTimeout(() => {
            const elmnt = document.getElementById("myDIV");
            if (elmnt) {
                const menuWidth = elmnt.offsetWidth;
                if (menuWidth !== null) {
                    if (menuWidth > window.innerWidth) {
                        setHideRightArrow(false);
                        setHideLeftArrowRTL(false);
                    } else {
                        setHideRightArrow(true);
                        setHideLeftArrowRTL(true);
                    }
                }
            }
        }, 500);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
        // eslint-disable-next-line
    }, []);

    const handleResize = () => {
        setWidth(window.innerWidth - 310);
    }

    const toggletNavActive = (item) => {
        // Tüm menüyü recursive olarak dolaşıp active durumlarını güncelleyen yardımcı fonksiyon
        const updateMenuItems = (items, targetItem) => {
            return items.map(menuItem => {
                // Menü öğesinin kendisini ve alt öğelerini kontrol et
                const isTarget = menuItem === targetItem;

                // Alt menüleri recursive olarak güncelle
                const updatedItem = {
                    ...menuItem,
                    active: isTarget ? !menuItem.active : false, // Sadece hedef öğeyi toggle yap, diğerlerini kapat
                    children: menuItem.children
                        ? updateMenuItems(menuItem.children, targetItem)
                        : menuItem.children
                };

                // Eğer alt menülerden herhangi biri active ise, üst menüyü de active yap
                if (updatedItem.children && updatedItem.children.some(child => child.active)) {
                    updatedItem.active = true;
                }

                return updatedItem;
            });
        };

        // Ana menüyü güncelle
        const updatedMenu = updateMenuItems([...mainmenu], item);
        setMainMenu(updatedMenu);

        // Mobile cihaz kontrolü
        if (isMobile && item.type === 'link') {
            document.querySelector(".page-main-header").classList.add('open');
            document.querySelector(".page-sidebar").classList.add('open');
        }
    };
    // Scrolling functions remain the same
    const scrollToRight = () => {
        const elmnt = document.getElementById("myDIV");
        const menuWidth = elmnt.offsetWidth;
        const temp = menuWidth + margin;
        if (temp < menuWidth) {
            setMargin(-temp);
            setHideRightArrow(true);
        }
        else {
            setMargin(margin => margin += (-width));
            setHideLeftArrow(false);
        }
    }

    const scrollToLeft = () => {
        if (margin >= -width) {
            setMargin(0)
            setHideLeftArrow(true);
        }
        else {
            setMargin(margin => margin += width);
            setHideRightArrow(false);
        }
    }

    const scrollToLeftRTL = () => {
        if (margin <= -width) {
            setMargin(margin => margin += -width);
            setHideLeftArrowRTL(true);
        }
        else {
            setMargin(margin => margin += -width);
            setHideRightArrowRTL(false);
        }
    }

    const scrollToRightRTL = () => {
        const temp = width + margin
        if (temp === 0) {
            setMargin(temp);
            setHideRightArrowRTL(true);
        }
        else {
            setMargin(margin => margin += width);
            setHideRightArrowRTL(false);
            setHideLeftArrowRTL(false);
        }
    }

    return (
        <Fragment>
            <div className="page-sidebar bg-white light-sidebar">
                <Link to="/index">
                    <div className="main-header-left d-none d-lg-block">
                        <div className="logo-wrapper compactLogo">
                            <img alt="logos" style={{ "width": "70px" }} src={logo} />
                        </div>
                    </div>
                </Link>
                <div className="sidebar custom-scrollbar">
                    <ul
                        className="sidebar-menu"
                        id="myDIV"
                        style={wrapper === 'horizontal_sidebar' ? layout === 'rtl' ?
                            { 'marginRight': margin + 'px', 'paddingBottom': '90px' } : { 'marginLeft': margin + 'px', 'paddingBottom': '90px' } : { margin: '0px', 'paddingBottom': '90px' }}
                    >
                        <li className={`left-arrow ${layout === 'rtl' ? hideLeftArrowRTL ? 'd-none' : '' : hideLeftArrow ? 'd-none' : ''}`}
                            onClick={(wrapper === 'horizontal_sidebar' && layout === 'rtl') ? scrollToLeftRTL : scrollToLeft}>
                            <i className="fa fa-angle-left"></i>
                        </li>
                        {
                            mainmenu.map((menuItem, i) => {
                                if (sidebarRoleManagement(menuItem.permissions)) {
                                    return (
                                        <li className={`${menuItem.active ? 'active' : ''}`} key={i}>
                                            {menuItem.sidebartitle &&
                                                <div className="sidebar-title">{menuItem.sidebartitle}</div>
                                            }
                                            {menuItem.type === 'sub' ? (
                                                <a className={`sidebar-header ${menuItem.active ? 'active' : ''}`}
                                                    href="#javascript"
                                                    onClick={() => toggletNavActive(menuItem)}>
                                                    <menuItem.icon style={{ color: `${menuItem.color}` }} />
                                                    <span>
                                                        {props.t(getFormatMessage(menuItem.title))}
                                                        {menuItem.isNew &&
                                                            <Badge pill variant="danger" style={{ marginLeft: "10px", marginTop: "-2px" }}>New</Badge>
                                                        }
                                                        {menuItem.isBeta &&
                                                            <Badge pill variant="danger" style={{ marginLeft: "10px", marginTop: "-2px" }}>Beta</Badge>
                                                        }
                                                    </span>
                                                    <i className="fa fa-angle-right pull-right"></i>
                                                </a>
                                            ) : menuItem.type === 'link' ? (
                                                <Link
                                                    to={`${process.env.PUBLIC_URL}${menuItem.path}`}
                                                    className={`sidebar-header ${menuItem.active ? 'active' : ''}`}
                                                    onClick={() => toggletNavActive(menuItem)}
                                                >
                                                    <menuItem.icon />
                                                    <span>
                                                        {props.t(getFormatMessage(menuItem.title))}
                                                        {menuItem.isNew &&
                                                            <Badge pill variant="danger" style={{ marginLeft: "10px", marginTop: "-2px" }}>New</Badge>
                                                        }
                                                        {menuItem.isBeta &&
                                                            <Badge pill variant="danger" style={{ marginLeft: "10px", marginTop: "-2px" }}>Beta</Badge>
                                                        }
                                                    </span>
                                                    {menuItem.children &&
                                                        <i className="fa fa-angle-right pull-right"></i>
                                                    }
                                                </Link>
                                            ) : null}
                                            {menuItem.children && (
                                                <ul
                                                    className={`sidebar-submenu ${menuItem.active ? 'menu-open' : ''}`}
                                                    style={menuItem.active ? { opacity: 1, transition: 'opacity 500ms ease-in' } : {}}
                                                >
                                                    {menuItem.children.map((childrenItem, index) => {
                                                        if (sidebarRoleManagement(childrenItem.permissions)) {
                                                            return (
                                                                <li key={index} className={childrenItem.children ? childrenItem.active ? 'active' : '' : ''}>
                                                                    {childrenItem.type === 'sub' ? (
                                                                        <a href="#javascript"
                                                                            onClick={() => toggletNavActive(childrenItem)}
                                                                            className={childrenItem.active ? 'active' : ''}>
                                                                            <i className="fa fa-circle"></i>
                                                                            {props.t(getFormatMessage(childrenItem.title))}
                                                                            <i className="fa fa-angle-right pull-right"></i>
                                                                        </a>
                                                                    ) : childrenItem.type === 'link' ? (
                                                                        <Link
                                                                            to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                                                                            className={childrenItem.active ? 'active' : ''}
                                                                            onClick={() => toggletNavActive(childrenItem)}
                                                                        >
                                                                            <i className="fa fa-circle"></i>
                                                                            <span>
                                                                                {props.t(getFormatMessage(childrenItem.title))}
                                                                                {childrenItem.isNew &&
                                                                                    <Badge pill variant="danger" style={{ marginLeft: "10px", marginTop: "-2px" }}>New</Badge>
                                                                                }
                                                                                {childrenItem.isBeta &&
                                                                                    <Badge pill variant="danger" style={{ marginLeft: "10px", marginTop: "-2px" }}>Beta</Badge>
                                                                                }
                                                                            </span>
                                                                        </Link>
                                                                    ) : null}
                                                                    {childrenItem.children && (
                                                                        <ul className={`sidebar-submenu ${childrenItem.active ? 'menu-open' : ''}`}>
                                                                            {childrenItem.children.map((childrenSubItem, key) => {
                                                                                if (sidebarRoleManagement(childrenSubItem.permissions)) {
                                                                                    return (
                                                                                        <li className={childrenSubItem.active ? 'active' : ''} key={key}>
                                                                                            {childrenSubItem.type === 'link' && (
                                                                                                <Link
                                                                                                    to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                                                                                                    className={childrenSubItem.active ? 'active' : ''}
                                                                                                    onClick={() => toggletNavActive(childrenSubItem)}
                                                                                                >
                                                                                                    <i className="fa fa-circle"></i>
                                                                                                    {props.t(getFormatMessage(childrenSubItem.title))}
                                                                                                </Link>
                                                                                            )}
                                                                                        </li>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            })}
                                                                        </ul>
                                                                    )}
                                                                </li>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </ul>
                                            )}
                                        </li>
                                    );
                                }
                                return null;
                            })
                        }
                        <li className={`right-arrow ${layout === 'rtl' ? hideRightArrowRTL ? 'd-none' : '' : hideRightArrow ? 'd-none' : ''}`}
                            onClick={(wrapper === 'horizontal_sidebar' && layout === 'rtl') ? scrollToRightRTL : scrollToRight}>
                            <i className="fa fa-angle-right"></i>
                        </li>
                    </ul>

                    {/* Support Request Link */}
                    <div className="sidebar-support" style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        borderTop: '1px solid #e9ecef',
                        backgroundColor: '#f8f9fa',
                        minHeight: '70px'
                    }}>
                        <a
                            href="https://uklojistik-destek.xurrent.qa/inbox#table=true"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sidebar-header support-link"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '18px 20px',
                                backgroundColor: 'transparent',
                                border: 'none',
                                borderRadius: '0',
                                textDecoration: 'none',
                                color: '#495057',
                                fontSize: '14px',
                                fontWeight: '500',
                                transition: 'all 0.2s ease',
                                cursor: 'pointer',
                                width: '100%',
                                minHeight: '70px'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f1f3f4';
                                e.target.style.color = '#1565c0';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = '#495057';
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '36px',
                                height: '36px',
                                backgroundColor: '#2196f3',
                                borderRadius: '8px',
                                marginRight: '14px',
                                boxShadow: '0 2px 8px rgba(33, 150, 243, 0.2)'
                            }}>
                                <i className="fa fa-support" style={{
                                    fontSize: '16px',
                                    color: '#ffffff'
                                }}></i>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    marginBottom: '2px',
                                    color: '#212529',
                                    letterSpacing: '0.3px'
                                }}>
                                    Destek Talebi Oluştur
                                </div>
                                <div style={{
                                    fontSize: '12px',
                                    color: '#6c757d',
                                    fontWeight: '400',
                                    lineHeight: '1.3'
                                }}>
                                    Sistem hataları ve öneriler
                                </div>
                            </div>
                            <i className="fa fa-chevron-right" style={{
                                fontSize: '12px',
                                color: '#2196f3',
                                opacity: '0.8'
                            }}></i>
                        </a>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default translate(Sidebar);